import {configureStore} from '@reduxjs/toolkit';
import appReducer from '../model/app';
import userReducer from '../model/user';

export const store = configureStore({
    reducer: {
        user: userReducer,
        app : appReducer
    },
});
